<template>
  <div id="stock-chart"></div>
</template>

<script>
import Highcharts from "highcharts/highstock";
import Exporting from "highcharts/modules/exporting";
import ExportData from "highcharts/modules/export-data";

Exporting(Highcharts);
ExportData(Highcharts);

export default {
  props: {
    chart: Array,
  },
  data() {
    return {
      stockChart: null,
    };
  },
  mounted() {
    this.createChart();
  },
  methods: {
    createChart() {
      console.log('CreateChart', this.chart);
      this.stockChart = Highcharts.stockChart("stock-chart", this.chart
        // {
        //   chart: {
        //     backgroundColor: "transparent",
        //   },
        //   rangeSelector: {
        //     selected: 1,
        //   },

        //   title: {
        //     text: "Vibration Sensor Graph",
        //     align: "left",
        //     style: {
        //       color: "#808080",
        //       fontSize: "18px",
        //       "font-weight": "900",
        //     },
        //   },

        //   series: [
        //     {
        //       name: "AAPL",
        //       data: dataA,
        //       tooltip: {
        //         valueDecimals: 2,
        //       },
        //     },
        //     {
        //       name: "BBPL",
        //       data: dataB,
        //       tooltip: {
        //         valueDecimals: 2,
        //       },
        //     },
        //     {
        //       name: "CCPL",
        //       data: dataC,
        //       tooltip: {
        //         valueDecimals: 2,
        //       },
        //     },
        //   ],
        // }
      );

      // resize chart
      const ro = new ResizeObserver((entries) => {
        this.stockChart.reflow();
      });
      ro.observe(document.getElementById("stock-chart"))
    },
  },
  watch: {
    chart: {
      handler(newValue, oldValue) {
        console.log('redraw chart', this.chart, this.stockChart);
        // this.stockChart.update(this.chart.series);
        // this.stockChart.update(this.chart);
        if (this.stockChart)
          this.stockChart.update({ series: this.chart.series })

        // Note: `newValue` will be equal to `oldValue` here
        // on nested mutations as long as the object itself
        // hasn't been replaced.
      },
      deep: true
    }
  },
};
</script>

<style>

</style>